export enum PermissionType {
  Full = 1,
  View = 2,
  None = 3,
}
